var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M31.928 25.744a4.923 4.923 0 1 0 0-9.846 4.923 4.923 0 0 0 0 9.846m2.924-4.923a2.923 2.923 0 1 1-5.847 0 2.923 2.923 0 0 1 5.847 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M48.005 28.85c0 10.493-8.506 19-19 19s-19-8.507-19-19 8.507-19 19-19 19 8.506 19 19m-2 0c0 9.389-7.61 17-17 17-9.388 0-17-7.611-17-17 0-9.39 7.611-17 17-17 9.39 0 17 7.61 17 17",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M43.296 48.734a1 1 0 0 1 0-1.415l3.68-3.678a1 1 0 0 1 1.413 1.414l-3.678 3.679a1 1 0 0 1-1.415 0M65.596 59.709c1.398 1.398 1.949 2.806 1.995 4.007a4.05 4.05 0 0 1-1.175 3.045 4.04 4.04 0 0 1-3.042 1.176c-1.2-.046-2.61-.597-4.01-1.997L45.73 52.306a1 1 0 0 0-1.414 1.414L57.95 67.355c1.698 1.697 3.567 2.513 5.348 2.58a6.04 6.04 0 0 0 4.533-1.76 6.05 6.05 0 0 0 1.758-4.535c-.068-1.781-.883-3.65-2.579-5.345L53.376 44.66a1 1 0 0 0-1.414 1.415z"
  })));
};
export default SvgSearch;